import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import FiltersIcon from "../../assets/icons/filter.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { proxyAPI } from "../proxyAPI";
import MyPagination from "../Common/MyPagination";
import ImportContactsModal, {
  ImportedContactFileInfoType,
  ImportedRecords,
} from "../Broadcast/ImportContactsModal";
import { getImportedFileName } from "../helpers";
import EmailIcon from "../../assets/icons/icon_email-01.svg2";
import MessageIcon from "../../assets/icons/messages.svg2";
import VoiceIcon from "../../assets/icons/icon_voice_tel-01.svg2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import MyModal from "../Common/MyModal";
import ImportedContactFilesLibraryIcon from "../../assets/icons/icon_contacts-01.svg2";
import Subheading from "../Common/Subheading";
import HelpButton from "../HelpContent/HelpButton";

const { countries } = JSON.parse(
  (document.querySelector("#app") as any)?.dataset?.page
).props;

export default function ImportedContactFilesFilters({
  filters,
  setFilters,
}: {
  filters: {
    status?: string;
    search?: string;
  };
  setFilters: React.Dispatch<
    React.SetStateAction<{
      status?: string;
      search?: string;
    }>
  >;
}) {
  return (
    <>
      <div>
        <label className="fw-bold p-2 text-white">Status:</label>
        <Input
          value={[filters?.status]}
          onChange={(v: React.SetStateAction<string>[]) => {
            setFilters((prev: any) => ({ ...prev, status: v[0] }));
          }}
          inputType="radio"
          options={[
            { value: "processed", label: "PROCESSED" },
            { value: "processing", label: "PROCESSING" },
            { value: "created", label: "CREATED" },
            { value: "deleted", label: "DELETED" },
            { value: "", label: "ALL" },
          ]}
        />
      </div>
    </>
  );
}
